export const ACCESS_COOKIE_NAME = 'sales_events_access'
